import React from "react";
import Header from "../General/Header";
import Footer from "./Footer";

const PrivacyPolicy = () => {
  return (
    <>
      <Header />

      <div
        style={{
          background: "#0f172a",
          color: "#fff",
          minHeight: "100vh",
        }}
      >
        {/* Hero Section */}
        <section
          style={{
            padding: "90px 20px",
            textAlign: "center",
            background:
              "linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #111827 100%)",
          }}
        >
          <h1
            style={{
              fontSize: "55px",
              fontWeight: "bold",
              marginBottom: "20px",
            }}
          >
            Privacy Policy
          </h1>

          <p
            style={{
              maxWidth: "850px",
              margin: "auto",
              color: "#cbd5e1",
              fontSize: "20px",
              lineHeight: "34px",
            }}
          >
            Your privacy and data security are important to us. This
            Privacy Policy explains how we collect, use, and protect
            your information while using our trading platform.
          </p>
        </section>

        {/* Content Section */}
        <section
          style={{
            padding: "80px 20px",
          }}
        >
          <div
            style={{
              maxWidth: "1100px",
              margin: "auto",
              background: "#1e293b",
              padding: "50px",
              borderRadius: "20px",
            }}
          >
            {/* Section 1 */}
            <div style={{ marginBottom: "45px" }}>
              <h2
                style={{
                  fontSize: "32px",
                  marginBottom: "15px",
                }}
              >
                1. Information We Collect
              </h2>

              <p
                style={{
                  color: "#cbd5e1",
                  lineHeight: "32px",
                  fontSize: "17px",
                }}
              >
                We may collect personal information including your name,
                email address, phone number, wallet details, and trading
                activity when you register or use our platform.
              </p>
            </div>

            {/* Section 2 */}
            <div style={{ marginBottom: "45px" }}>
              <h2
                style={{
                  fontSize: "32px",
                  marginBottom: "15px",
                }}
              >
                2. How We Use Your Information
              </h2>

              <p
                style={{
                  color: "#cbd5e1",
                  lineHeight: "32px",
                  fontSize: "17px",
                }}
              >
                Your information is used to manage your account,
                improve platform performance, provide customer support,
                process transactions, and enhance trading security.
              </p>
            </div>

            {/* Section 3 */}
            <div style={{ marginBottom: "45px" }}>
              <h2
                style={{
                  fontSize: "32px",
                  marginBottom: "15px",
                }}
              >
                3. Data Protection
              </h2>

              <p
                style={{
                  color: "#cbd5e1",
                  lineHeight: "32px",
                  fontSize: "17px",
                }}
              >
                We implement strong security measures and encryption
                technologies to protect your personal and financial
                information from unauthorized access.
              </p>
            </div>

            {/* Section 4 */}
            <div style={{ marginBottom: "45px" }}>
              <h2
                style={{
                  fontSize: "32px",
                  marginBottom: "15px",
                }}
              >
                4. Cookies & Tracking
              </h2>

              <p
                style={{
                  color: "#cbd5e1",
                  lineHeight: "32px",
                  fontSize: "17px",
                }}
              >
                Our website may use cookies and analytics tools to
                improve user experience, track activity, and optimize
                platform performance.
              </p>
            </div>

            {/* Section 5 */}
            <div style={{ marginBottom: "45px" }}>
              <h2
                style={{
                  fontSize: "32px",
                  marginBottom: "15px",
                }}
              >
                5. Third-Party Services
              </h2>

              <p
                style={{
                  color: "#cbd5e1",
                  lineHeight: "32px",
                  fontSize: "17px",
                }}
              >
                We may work with trusted third-party payment gateways
                and services to process transactions securely. These
                providers follow their own privacy policies.
              </p>
            </div>

            {/* Section 6 */}
            <div style={{ marginBottom: "45px" }}>
              <h2
                style={{
                  fontSize: "32px",
                  marginBottom: "15px",
                }}
              >
                6. User Rights
              </h2>

              <p
                style={{
                  color: "#cbd5e1",
                  lineHeight: "32px",
                  fontSize: "17px",
                }}
              >
                Users have the right to access, update, or request
                deletion of their personal information according to
                applicable laws and regulations.
              </p>
            </div>

            {/* Section 7 */}
            <div style={{ marginBottom: "20px" }}>
              <h2
                style={{
                  fontSize: "32px",
                  marginBottom: "15px",
                }}
              >
                7. Policy Updates
              </h2>

              <p
                style={{
                  color: "#cbd5e1",
                  lineHeight: "32px",
                  fontSize: "17px",
                }}
              >
                We may update this Privacy Policy from time to time.
                Changes will be posted on this page with an updated
                revision date.
              </p>
            </div>

            {/* Footer Text */}
            <div
              style={{
                marginTop: "50px",
                borderTop: "1px solid #334155",
                paddingTop: "25px",
              }}
            >
              <p
                style={{
                  color: "#94a3b8",
                  textAlign: "center",
                  fontSize: "15px",
                }}
              >
                Last Updated: May 2026
              </p>
            </div>
          </div>
        </section>
      </div>
      <Footer/>
    </>
  );
};

export default PrivacyPolicy;